const {Component} = require("react");
const PropTypes = require("prop-types");
const {classList} = require("helpers/html");
const router = require("services/router");

class RecipientSelector extends Component {

	static get propTypes() {
		return {
			options: PropTypes.array,
			value: PropTypes.array,
			defaultAvatarUrl: PropTypes.string,
			label: PropTypes.string,
			handleChange: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			options: [],
			value: [],
			defaultAvatarUrl: "img/avatar-placeholder.png",
			label: "Vælg modtagere"
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			options: props.options,
			value: props.value
		};
	}

	get value() {
		return this.state.value;
	}

	handleChange = () => {
		if (typeof this.props.handleChange === "function") {
			this.props.handleChange(this.state.value);
		}
	};

	optionClickListener(option) {
		return e => {
			e.preventDefault();
			e.stopPropagation();

			const index = this.state.value.indexOf(option);

			if (index === -1) {
				return this.setState(state => {
					state.value.push(option);
					return state;
				}, this.handleChange);
			}
			else {
				// Do not remove if there's only one option selected
				if (this.state.value.length > 1) {
					this.setState(state => {
						state.value.splice(index, 1);
						return state;
					}, this.handleChange);
				}
			}
		};
	}

	renderOptions() {
		return this.state.options.map(option => {
			const avatarUrl = option.avatar ? option.avatar.url : router.url(this.props.defaultAvatarUrl);
			const ageMarkup = typeof option.age === "number" ? (<span className="recipient-age">{option.age} år</span>) : null;
			const levelMarkup = (option.levels instanceof Array) && (option.levels.length > 0) ?
				(<span className="recipient-levels">{option.levels.join(", ")}</span>) : null;
			const selected = this.state.value.indexOf(option) !== -1;
			const className = classList(
				"recipient-option",
				selected ? "selected" : null
			);

			return (
				<div className={className} key={option.key} onClick={this.optionClickListener(option)}>
					<img src={avatarUrl} alt={option.name}/>
					<div>
						<span className="recipient-name">{option.name}</span>
						{ageMarkup}
						{levelMarkup}
					</div>
				</div>
			);
		});
	}

	render() {
		return (
			<div className="recipient-selector">
				<p>{this.props.label}</p>
				<div className="recipient-selector-options">{this.renderOptions()}</div>
			</div>
		);
	}

}

module.exports = RecipientSelector;


// WEBPACK FOOTER //
// ./resources/js/components/checkout/RecipientSelector.js